import { Link } from 'react-router-dom';

export default function AcessoNegadoPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dominant px-md">
      <div className="max-w-[448px] text-center">
        <h1 className="text-[20px] font-bold text-ink mb-sm">Acesso negado</h1>
        <p className="text-[14px] text-ink-soft">
          Seu usuário não tem acesso a esta tela. Peça ao administrador da empresa para liberar o módulo ou a
          permissão de que você precisa.
        </p>
        <Link
          to="/"
          className="mt-lg inline-flex h-10 items-center rounded-lg bg-accent px-md text-[14px] font-bold text-white hover:bg-accent/90"
        >
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}
